export default __webpack_public_path__ + "static/2-11429f243a094311640fdf7e3db63b0d.jpeg";